<template>
	<section class="view-venue-checkins padded default-panel">
		<ViewLayoutModuleHeader title="Shooters in the area">
			<RouterLink v-bind:to="{ name: 'PagePlaceCheckins', params: { id: venueModel.getSlug() } }">
				View All
			</RouterLink>
		</ViewLayoutModuleHeader>

		<ChalkyVenueCheckins
			v-bind:key="venueModel.checkins.uniqueKey"
			v-bind:venueModel="venueModel"
			v-on:user:select="Handle_OnSelectUser"
		/>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * Displays check-ins for a venue with a link to view all.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Venue
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewVenueCheckins extends ViewBase {
		/**
		 * The venue model containing checkin data
		 *
		 * @type ChalkySticks.Model.Venue
		 */
		@Prop({
			default: () => ChalkySticks.Factory.Venue.model(),
		})
		public venueModel!: ChalkySticks.Model.Venue;

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * Emits the selected user to the parent component
		 *
		 * @param ChalkySticks.Model.User userModel
		 * @return void
		 */
		protected Handle_OnSelectUser(userModel: ChalkySticks.Model.User): void {
			this.$emit('user:select', userModel);
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-venue-checkins {
		.venue-checkins-requestaction,
		.venue-checkins-confirmation {
			margin-top: 2rem;
			padding: 0;
		}
	}
</style>
